import React from 'react';
import { Box } from '../Box/Box';
import { Link } from '../Link/Link';
import { Type } from '../Type/Type';

var SecureLockIcon = function SecureLockIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    marginRight: "2",
    display: "flex"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "27",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0h5.226c1.742 3.484 4.5 5.661 8.274 6.532 0 13.392-4.5 21.811-13.5 25.258V0z",
    fill: "#EAA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H8.274C6.532 3.484 3.774 5.661 0 6.532 0 19.924 4.5 28.343 13.5 31.79V0z",
    fill: "#FFB836"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "13.5",
    cy: "15.242",
    r: "7.839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.838 13.062v-.878c0-.367-.133-.684-.398-.949a1.296 1.296 0 0 0-.95-.398c-.367 0-.683.133-.949.398a1.296 1.296 0 0 0-.398.95v.877h2.695zm-1.96 3.654a.841.841 0 0 0 .613.265.841.841 0 0 0 .612-.265.841.841 0 0 0 .265-.612.841.841 0 0 0-.265-.613.841.841 0 0 0-.612-.265.841.841 0 0 0-.613.265.841.841 0 0 0-.265.613c0 .23.088.435.265.612zm3.226-3.654c.23 0 .435.085.612.255.177.17.265.371.265.602v4.369a.808.808 0 0 1-.265.602.858.858 0 0 1-.612.255h-5.226a.858.858 0 0 1-.613-.255.808.808 0 0 1-.265-.602v-4.369c0-.231.088-.432.265-.602a.858.858 0 0 1 .613-.255h.428v-.878c0-.599.215-1.112.643-1.541A2.102 2.102 0 0 1 13.491 10c.598 0 1.112.214 1.54.643.43.429.644.942.644 1.541v.878h.429z",
    fill: "#4A4A4A"
  }))));
};

export var SecureEncryptionMessage = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, {
    display: "inline-flex",
    alignItems: "center",
    ref: ref
  }, /*#__PURE__*/React.createElement(SecureLockIcon, null), /*#__PURE__*/React.createElement(Type, {
    size: 1
  }, "Your info is secured with 128-bit encryption. ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
    href: "/l/security",
    target: "_blank"
  }, "See how we prioritize your security")));
});
SecureEncryptionMessage.displayName = 'SecureEncryptionMessage';